import {
  ConfigurationSetting,
  ConfigurationSettingCodes,
} from '@maximizer/core/shared/domain';
import { IQDataProcessingFeatures } from '@maximizer/ai/data-access';

export const DATA_PROCESSING_SETTING_CODES: ConfigurationSettingCodes = {
  code3: 'aiIQBoostConfigurationFilters',
  code4: 'filterConfiguration',
};

type AnonymizationFeatures = Pick<IQDataProcessingFeatures, 'anonymized'>;

function parseDataProcessingFeatures(
  setting: ConfigurationSetting | null | undefined,
): IQDataProcessingFeatures | null {
  if (!setting?.textValue) return null;
  try {
    return JSON.parse(setting.textValue)?.dataProcessingFeatures ?? null;
  } catch {
    return null;
  }
}

export function parseUserAnonymization(
  setting: ConfigurationSetting | null | undefined,
): boolean {
  return parseDataProcessingFeatures(setting)?.anonymized ?? false;
}

export function parseAdminAnonymizationFeatures(
  setting: ConfigurationSetting | null | undefined,
): AnonymizationFeatures | null {
  return parseDataProcessingFeatures(setting);
}

export function isAdminAnonymizationEnabled(
  adminFeatures: AnonymizationFeatures | null | undefined,
): boolean {
  return adminFeatures?.anonymized === true;
}

export function resolveAnonymizationEnabled(
  userSetting: ConfigurationSetting | null | undefined,
  adminFeatures: AnonymizationFeatures | null | undefined,
): boolean {
  return (
    isAdminAnonymizationEnabled(adminFeatures) ||
    parseUserAnonymization(userSetting)
  );
}

export function parseAdminDataProcessingFeatures(
  setting: ConfigurationSetting | null | undefined,
): IQDataProcessingFeatures | null {
  return parseDataProcessingFeatures(setting);
}
